<template>
  <div class="e-waste-modern">
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container">
        <el-breadcrumb class="breadcrumb">
          <el-breadcrumb-item
          ><span class="breadcrumb_span" @click="backHome"
          >政务服务</span
          ></el-breadcrumb-item
          >
          <el-breadcrumb-item>废弃电子产品回收</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="hero-title">废弃电子产品回收服务</h1>
        <p class="hero-subtitle">环保处理 · 数据销毁 · 资源再生</p>
        <div class="hero-stats">
          <div class="stat-item" v-for="stat in heroStats" :key="stat.id">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区 -->
      <div class="content-layout">
        <!-- 左侧主内容 -->
        <div class="main-content">
          <!-- 流程卡片 -->
          <el-card shadow="never" class="process-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-operation"></i>
              </div>
              <h2>回收处理流程</h2>
              <el-tag type="success" effect="plain">4个步骤</el-tag>
            </div>

            <div class="process-steps">
              <div
                  class="process-step"
                  v-for="(step, index) in processSteps"
                  :key="index"
                  :style="{ '--step-color': step.color }"
              >
                <div class="step-number">{{ index + 1 }}</div>
                <div class="step-content">
                  <div class="step-header">
                    <h3>{{ step.title }}</h3>
                    <el-tag v-if="step.time" size="small">{{ step.time }}</el-tag>
                  </div>
                  <p>{{ step.description }}</p>
                  <ul class="step-details" v-if="step.details">
                    <li v-for="(detail, i) in step.details" :key="i">
                      <i class="el-icon-check"></i> {{ detail }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 回收类别 -->
          <el-card shadow="never" class="category-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-grid"></i>
              </div>
              <h2>回收类别</h2>
              <el-tag type="primary" effect="plain">{{ categories.length }}类</el-tag>
            </div>

            <div class="category-grid">
              <div
                  class="category-item"
                  v-for="item in categories"
                  :key="item.type"
                  :style="{ '--item-color': item.color }"
              >
                <div class="category-icon">
                  <i :class="item.icon"></i>
                </div>
                <div class="category-info">
                  <div class="category-type">{{ item.type }}</div>
                  <div class="category-examples">{{ item.examples }}</div>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 申请表单 -->
          <el-card shadow="never" class="form-card glassmorph" v-if="showForm">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-edit"></i>
              </div>
              <h2>回收申请</h2>
            </div>

            <el-form
                :model="form"
                :rules="rules"
                ref="formRef"
                label-position="top"
                class="recycle-form"
            >
              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="联系人姓名" prop="contactName">
                    <el-input
                        v-model="form.contactName"
                        placeholder="请输入联系人姓名"
                        prefix-icon="el-icon-user"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="联系电话" prop="phone">
                    <el-input
                        v-model="form.phone"
                        placeholder="请输入联系电话"
                        prefix-icon="el-icon-phone"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="电子设备类型" prop="deviceType">
                    <el-select
                        v-model="form.deviceType"
                        placeholder="请选择设备类型"
                        style="width: 100%"
                    >
                      <el-option
                          v-for="item in deviceTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="设备数量" prop="quantity">
                    <el-input-number
                        v-model="form.quantity"
                        :min="1"
                        :max="100"
                        label="请输入设备数量"
                        style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="回收方式" prop="recycleMethod">
                <el-radio-group v-model="form.recycleMethod">
                  <el-radio-button label="self">自行送交</el-radio-button>
                  <el-radio-button label="pickup">上门回收</el-radio-button>
                  <el-radio-button label="mail">邮寄回收</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                  label="选择回收点"
                  prop="recycleLocation"
                  v-if="form.recycleMethod === 'self'"
              >
                <el-select
                    v-model="form.recycleLocation"
                    placeholder="请选择回收点"
                    style="width: 100%"
                >
                  <el-option
                      v-for="loc in recycleLocations"
                      :key="loc.id"
                      :label="loc.name"
                      :value="loc.id"
                  >
                    <div class="location-option">
                      <span>{{ loc.name }}</span>
                      <span class="location-address">{{ loc.address }}</span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                  label="预约时间"
                  prop="appointmentTime"
                  v-if="form.recycleMethod === 'pickup'"
              >
                <el-date-picker
                    v-model="form.appointmentTime"
                    type="datetime"
                    placeholder="选择预约时间"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                  label="邮寄地址"
                  prop="mailAddress"
                  v-if="form.recycleMethod === 'mail'"
              >
                <el-input
                    v-model="form.mailAddress"
                    placeholder="请输入邮寄地址"
                    prefix-icon="el-icon-location"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="设备照片" prop="images">
                <el-upload
                    action="#"
                    list-type="picture-card"
                    :auto-upload="false"
                    :on-change="handleImageChange"
                    :file-list="form.images"
                    :limit="3"
                    multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="upload-tip">
                  请上传设备外观照片（最多3张）
                </div>
              </el-form-item>

              <el-form-item label="数据销毁要求" prop="dataDestruction">
                <el-checkbox-group v-model="form.dataDestruction">
                  <el-checkbox label="format">格式化存储设备</el-checkbox>
                  <el-checkbox label="physical">物理销毁存储介质</el-checkbox>
                  <el-checkbox label="certificate">需要销毁证明</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="备注" prop="remarks">
                <el-input
                    type="textarea"
                    v-model="form.remarks"
                    placeholder="请输入其他特殊要求或说明"
                    :rows="3"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                    type="primary"
                    size="large"
                    @click="submitForm"
                    class="submit-btn"
                >
                  <i class="el-icon-s-claim"></i> 提交申请
                </el-button>
                <el-button size="large" @click="resetForm"> 重置 </el-button>
              </el-form-item>
            </el-form>
          </el-card>

          <!-- 申请按钮 -->
          <div class="action-buttons" v-if="!showForm">
            <el-button
                type="primary"
                size="large"
                @click="showForm = true"
                class="apply-btn"
            >
              <i class="el-icon-edit"></i> 立即申请回收
            </el-button>
            <el-button size="large" @click="downloadGuide" class="download-btn">
              <i class="el-icon-download"></i> 下载回收指南
            </el-button>
          </div>
        </div>

        <!-- 右侧边栏 -->
        <div class="sidebar">
          <!-- 回收网点 -->
          <el-card shadow="never" class="location-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-location-information"></i>
              </div>
              <h2>回收网点</h2>
              <el-tag type="info" effect="plain"
              >{{ recycleLocations.length }}个网点</el-tag
              >
            </div>

            <el-input
                v-model="locationQuery"
                placeholder="搜索回收点"
                class="location-search"
                prefix-icon="el-icon-search"
            >
            </el-input>

            <div class="location-list">
              <div
                  class="location-item"
                  v-for="loc in filteredLocations"
                  :key="loc.id"
              >
                <div class="location-info">
                  <h3>{{ loc.name }}</h3>
                  <p><i class="el-icon-location"></i> {{ loc.address }}</p>
                  <p><i class="el-icon-phone"></i> {{ loc.phone }}</p>
                  <p><i class="el-icon-time"></i> {{ loc.businessHours }}</p>
                </div>
                <el-button type="text" @click="viewOnMap(loc)" class="map-btn">
                  <i class="el-icon-map-location"></i> 查看地图
                </el-button>
              </div>
            </div>
          </el-card>

          <!-- 环保效益 -->
          <el-card shadow="never" class="benefit-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-flag"></i>
              </div>
              <h2>环保效益</h2>
            </div>

            <div class="benefit-stats">
              <div class="benefit-item" v-for="item in benefitStats" :key="item.id">
                <div class="benefit-icon" :style="{ backgroundColor: item.color }">
                  <i :class="item.icon"></i>
                </div>
                <div class="benefit-content">
                  <div class="benefit-value">{{ item.value }}</div>
                  <div class="benefit-label">{{ item.label }}</div>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 常见问题 -->
          <el-card shadow="never" class="faq-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-question"></i>
              </div>
              <h2>常见问题</h2>
            </div>

            <el-collapse accordion>
              <el-collapse-item
                  v-for="(faq, index) in faqs"
                  :key="index"
                  :title="faq.question"
                  :name="index"
              >
                <div class="faq-answer" v-html="faq.answer"></div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/util/scrollTop';
export default {
  name: 'EWasteRecycle',
  data() {
    return {
      showForm: false,
      locationQuery: '',
      heroStats: [
        { id: 1, value: '1000+吨', label: '年回收处理量' },
        { id: 2, value: '95%+', label: '资源再利用率' },
        { id: 3, value: '99%', label: '数据安全率' },
      ],
      processSteps: [
        {
          title: '提交申请',
          description: '填写电子设备信息并提交回收申请',
          time: '即时',
          color: '#409EFF',
          details: ['在线填写申请表', '上传设备照片', '选择回收方式'],
        },
        {
          title: '审核确认',
          description: '工作人员审核申请信息',
          time: '1个工作日',
          color: '#67C23A',
          details: ['确认设备类型和数量', '确认回收方式', '通知审核结果'],
        },
        {
          title: '设备交接',
          description: '将设备移交至回收点或等待上门回收',
          time: '按预约时间',
          color: '#E6A23C',
          details: ['自行送交/上门回收/邮寄', '现场验收确认', '签署交接文件'],
        },
        {
          title: '专业处理',
          description: '环保拆解与数据销毁',
          time: '3-5个工作日',
          color: '#F56C6C',
          details: ['环保合规拆解', '专业数据销毁', '生成处理证明'],
        },
      ],
      categories: [
        {
          type: '电脑设备',
          examples: '台式机/笔记本/平板',
          icon: 'el-icon-monitor',
          color: '#409EFF'
        },
        {
          type: '手机通讯',
          examples: '手机/电话机/对讲机',
          icon: 'el-icon-mobile-phone',
          color: '#67C23A'
        },
        {
          type: '办公设备',
          examples: '打印机/复印机/扫描仪',
          icon: 'el-icon-printer',
          color: '#E6A23C'
        },
        {
          type: '家用电器',
          examples: '电视/冰箱/空调/洗衣机',
          icon: 'el-icon-refrigerator',
          color: '#F56C6C'
        },
        {
          type: '数码产品',
          examples: '相机/摄像机/音响',
          icon: 'el-icon-camera',
          color: '#9966CC'
        },
        {
          type: '其他电子',
          examples: '电池/线缆/配件',
          icon: 'el-icon-cpu',
          color: '#909399'
        }
      ],
      deviceTypes: [
        { value: 'computer', label: '电脑设备（台式机/笔记本/平板）' },
        { value: 'phone', label: '手机通讯设备' },
        { value: 'office', label: '办公设备（打印机/复印机等）' },
        { value: 'home_appliance', label: '家用电器' },
        { value: 'digital', label: '数码产品' },
        { value: 'other', label: '其他电子设备' }
      ],
      recycleLocations: [
        {
          id: 1,
          name: '电子环保回收中心',
          address: 'XX市高新区环保路88号',
          phone: '123-45678901',
          businessHours: '周一至周日 9:00-18:00',
          lat: 31.2304,
          lng: 121.4737,
        },
        {
          id: 2,
          name: '数码产品回收站',
          address: 'XX市城南区科技园66号',
          phone: '123-45678902',
          businessHours: '周一至周六 9:00-17:30',
          lat: 31.2204,
          lng: 121.4837,
        },
        {
          id: 3,
          name: '家电回收处理厂',
          address: 'XX市城北区绿园路33号',
          phone: '123-45678903',
          businessHours: '周一至周五 8:30-17:00',
          lat: 31.2404,
          lng: 121.4637,
        },
      ],
      benefitStats: [
        {
          id: 1,
          value: '减少80%污染',
          label: '相比填埋处理',
          icon: 'el-icon-delete',
          color: '#67C23A'
        },
        {
          id: 2,
          value: '节约90%能源',
          label: '相比原材料生产',
          icon: 'el-icon-lightning',
          color: '#E6A23C'
        },
        {
          id: 3,
          value: '回收85%材料',
          label: '可再利用比例',
          icon: 'el-icon-refresh',
          color: '#409EFF'
        },
        {
          id: 4,
          value: '100%安全',
          label: '数据销毁保障',
          icon: 'el-icon-lock',
          color: '#F56C6C'
        }
      ],
      form: {
        contactName: '',
        phone: '',
        deviceType: '',
        quantity: 1,
        recycleMethod: 'self',
        recycleLocation: '',
        appointmentTime: '',
        mailAddress: '',
        images: [],
        dataDestruction: [],
        remarks: ''
      },
      rules: {
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'change' },
        ],
        recycleLocation: [
          { required: true, message: '请选择回收地点', trigger: 'change' },
        ],
        appointmentTime: [
          { required: true, message: '请选择预约时间', trigger: 'change' },
        ],
        mailAddress: [
          { required: true, message: '请输入邮寄地址', trigger: 'blur' },
        ]
      },
      faqs: [
        {
          question: '哪些电子产品可以回收？',
          answer:
              '我们回收各类废弃电子产品，包括但不限于：电脑、手机、平板、打印机、复印机、电视机、冰箱、空调、洗衣机、数码相机、音响设备等。小型电子配件如键盘、鼠标、充电器等也可回收。',
        },
        {
          question: '回收的电子产品会如何处理？',
          answer:
              '所有回收的电子产品将按照环保标准进行处理：<br>1. 可用的设备经过检测后翻新再利用<br>2. 不可用设备进行专业拆解，分类回收金属、塑料等材料<br>3. 存储设备进行专业数据销毁<br>4. 有害物质如电池、汞等进行专业处理',
        },
        {
          question: '如何保证我的数据安全？',
          answer:
              '我们提供多种数据安全保障：<br>1. 专业数据擦除软件彻底格式化<br>2. 物理销毁存储介质（硬盘、内存等）<br>3. 提供数据销毁证明<br>4. 全程可追踪的处理流程',
        },
        {
          question: '回收电子产品有补贴吗？',
          answer:
              '根据国家政策和设备状况，部分电子产品回收可享受补贴：<br>1. 大型家电根据型号和使用年限可能有补贴<br>2. 部分品牌厂商提供以旧换新补贴<br>3. 政府支持的环保项目可能有额外奖励<br>具体补贴金额需根据设备评估确定。',
        },
      ],
    };
  },
  mounted() {
    scrollTop();
  },
  computed: {
    filteredLocations() {
      if (!this.locationQuery) {
        return this.recycleLocations.slice(0, 3);
      }
      return this.recycleLocations.filter((loc) => {
        return (
            loc.name.includes(this.locationQuery) ||
            loc.address.includes(this.locationQuery)
        );
      });
    },
  },
  methods: {
    handleImageChange(file, fileList) {
      this.form.images = fileList;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$message.success('回收申请提交成功！');
          this.showForm = false;
          // 这里可以添加API调用
        }
      });
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.form.images = [];
      this.form.quantity = 1;
      this.form.dataDestruction = [];
    },
    downloadGuide() {
      this.$message.success('开始下载回收指南');
      // 这里可以添加下载逻辑
    },
    viewOnMap(location) {
      // 这里可以集成地图功能
      this.$message.info(`查看 ${location.name} 的地图位置`);
    },
    backHome() {
      this.$emit('goBack', '');
    },
  },
};
</script>

<style lang="less" scoped>
.e-waste-modern {
  background-color: #f8fafc;
  min-height: 100vh;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  padding: 0 20px;
  margin: 0 auto 30px auto;
}

.hero-section {
  color: white;
  padding: 50px 0 50px;
  position: relative;
  margin-bottom: -40px;
  background: url('~@/assets/recycling/componyImages/feiqidianzi.png') center no-repeat;
  background-size: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      135deg,
      rgba(102, 194, 255, 0.8) 0%,
      rgba(58, 194, 103, 0.6) 100%
  );
  z-index: 0;
}

.hero-section > .container {
  position: relative;
  z-index: 1;
}

.breadcrumb_span {
  color: #000000;
  font-weight: 500;
  cursor: pointer;
}


.breadcrumb /deep/ .el-breadcrumb__item {
  color: rgba(255, 255, 255, 0.8);
}

.breadcrumb /deep/ .el-breadcrumb__item:last-child {
  color: white;
  font-weight: bold;
}

.breadcrumb /deep/ .el-breadcrumb__separator {
  color: rgba(255, 255, 255, 0.6);
}

.hero-title {
  font-size: 36px;
  font-weight: 600;
  margin: 20px 0 10px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 18px;
  opacity: 0.9;
  margin: 0 0 30px;
  font-weight: 300;
}

.hero-stats {
  display: flex;
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  line-height: 40px;
  margin-bottom: 8px;
  color: white;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
}

/* 内容布局 */
.content-layout {
  display: flex;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  min-width: 0;
}

.sidebar {
  width: 360px;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .content-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }
}

/* 卡片设计 */
.glassmorph {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.glassmorph:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.el-card {
  border: none;
  border-radius: 12px;
}

.el-card /deep/ .el-card__body {
  padding: 24px;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #66c2ff 0%, #3ac267 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 18px;
}

.card-header h2 {
  font-size: 20px;
  margin: 0;
  color: #333;
  flex: 1;
}

/* 流程步骤 */
.process-steps {
  display: grid;
  gap: 20px;
}

.process-step {
  display: flex;
  position: relative;
  padding-left: 56px;
}

.process-step::before {
  content: '';
  position: absolute;
  left: 28px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(
      to bottom,
      var(--step-color),
      rgba(var(--step-color), 0.3)
  );
  opacity: 0.3;
}

.process-step:last-child::before {
  display: none;
}

.step-number {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  border: 2px solid var(--step-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--step-color);
  z-index: 1;
  box-shadow: 0 4px 12px rgba(var(--step-color), 0.2);
}

.step-content {
  padding-bottom: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.step-header h3 {
  font-size: 16px;
  margin: 0 10px 0 0;
  font-weight: 600;
  color: var(--step-color);
}

.step-content p {
  font-size: 14px;
  margin: 0 0 8px;
  color: #666;
  line-height: 1.6;
}

.step-details {
  margin: 10px 0 0;
  padding-left: 20px;
  list-style: none;
}

.step-details li {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
  position: relative;
}

.step-details li i {
  position: absolute;
  left: -20px;
  color: var(--step-color);
}

/* 回收类别 */
.category-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.category-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  background: rgba(var(--item-color), 0.05);
  border-left: 3px solid var(--item-color);
  transition: all 0.3s;
}

.category-item:hover {
  background: rgba(var(--item-color), 0.1);
  transform: translateY(-2px);
}

.category-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(var(--item-color), 0.1);
  color: var(--item-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 12px;
}

.category-type {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
  color: var(--item-color);
}

.category-examples {
  font-size: 12px;
  color: #666;
}

/* 环保效益 */
.benefit-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.benefit-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  background: #f8fafc;
}

.benefit-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 12px;
}

.benefit-value {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 4px;
}

.benefit-label {
  font-size: 12px;
  color: #666;
}

/* 表单样式 */
.recycle-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #555;
  padding-bottom: 8px;
}

.recycle-form /deep/ .el-input__inner {
  height: 44px;
  border-radius: 8px;
}

.recycle-form /deep/ .el-radio-button__inner {
  border-radius: 8px !important;
}

.recycle-form /deep/ .el-checkbox {
  margin-right: 15px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.submit-btn {
  width: 180px;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 16px;
  margin: 30px 0;
}

.apply-btn {
  padding: 0 30px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(90deg, #66c2ff, #3ac267);
  border: none;
  box-shadow: 0 4px 12px rgba(102, 194, 255, 0.3);
}

.download-btn {
  padding: 0 30px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #dcdfe6;
}

/* 回收网点 */
.location-search {
  margin-bottom: 16px;
}

.location-search /deep/ .el-input__inner {
  border-radius: 20px;
  height: 40px;
}

.location-list {
  max-height: 400px;
  overflow-y: auto;
}

.location-item {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px dashed #ebeef5;
}

.location-item:last-child {
  border-bottom: none;
}

.location-info {
  flex: 1;
}

.location-info h3 {
  font-size: 15px;
  margin: 0 0 8px;
  color: #333;
}

.location-info p {
  font-size: 13px;
  margin: 4px 0;
  color: #666;
  display: flex;
  align-items: center;
}

.location-info i {
  margin-right: 6px;
  color: #999;
}

.map-btn {
  align-self: center;
  color: #66c2ff;
}

/* 常见问题 */
.faq-card /deep/ .el-collapse-item__header {
  font-size: 15px;
  font-weight: 500;
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
}

.faq-card /deep/ .el-collapse-item__content {
  padding: 12px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.faq-answer {
  padding-right: 20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .hero-stats {
    flex-direction: column;
    gap: 20px;
  }

  .category-grid,
  .benefit-stats {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .apply-btn,
  .download-btn {
    width: 100%;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.process-card,
.category-card,
.form-card,
.location-card,
.benefit-card,
.faq-card {
  animation: fadeInUp 0.6s ease-out forwards;
}

.process-card {
  animation-delay: 0.1s;
}
.category-card {
  animation-delay: 0.2s;
}
.form-card {
  animation-delay: 0.3s;
}
.location-card {
  animation-delay: 0.4s;
}
.benefit-card {
  animation-delay: 0.5s;
}
.faq-card {
  animation-delay: 0.6s;
}
</style>
